import { styled } from '@mgmresorts/wcl-styled';

export const StyledBackdrop = styled.div.attrs<{
  transitionDuration: number;
  backgroundColor: string;
  zIndex: number;
}>(({ transitionDuration, backgroundColor, zIndex }) => ({
  style: {
    backgroundColor,
    transitionDuration: transitionDuration ? `${transitionDuration}ms` : undefined,
    zIndex,
  },
}))<{
  transitionDuration: number;
  backgroundColor: string;
  zIndex: number;
  active: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 64px;
  color: ${p => {
    // Because of some reasons, mocking `ThemeContextProvider` in tests doesn't work
    // Thus, that's why we do the additional check `p.theme.colors &&` here.
    return p.theme.colors && p.theme.colors.interface;
  }};
  line-height: 1;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: opacity 0.3s;
  opacity: ${p => (p.active ? 1 : 0)};
  pointer-events: ${p => (p.active ? 'all' : 'none')};
  transition-timing-function: ${p => (p.active ? 'ease' : 'cubic-bezier(0.4, 0, 1, 1)')};
`;
